import React from "react";
import { Col, Stack } from "react-bootstrap";
import * as AiIcons from "react-icons/ai";
import { FormatInt } from "../../utils/FormatData";
import PropTypes from "prop-types";
import { Table } from "../../components/ui/Table";
const columns = [
  {
    accessor: "vc_customer",
    Header: () => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>Cliente</div>
      );
    },
    Footer: () => {
      return (
        <Col style={{ textAlign: "center", fontWeight: "bold" }}>Totales:</Col>
      );
    },
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <Col style={{ textAlign: "left", fontSize: "smaller" }}>
            {rowInfo.vc_customer}
          </Col>
        </>
      );
    },
  },
  {
    accessor: "i_telcel",
    Header: () => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>Telcel</div>
      );
    },

    showTotal: true,
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <Col style={{ textAlign: "center" }}>{FormatInt(rowInfo.i_telcel)}</Col>
      );
    },
    Footer: (columnData) => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          {FormatInt(
            columnData.data.reduce(
              (i_total, item) => i_total + Number(item.i_telcel),
              0,
            ),
          )}
        </div>
      );
    },
  },
  {
    accessor: "i_movistar",
    Header: () => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>Movistar</div>
      );
    },

    showTotal: true,
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <Col style={{ textAlign: "center" }}>
          {FormatInt(rowInfo.i_movistar)}
        </Col>
      );
    },
    Footer: (columnData) => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          {FormatInt(
            columnData.data.reduce(
              (i_total, item) => i_total + Number(item.i_movistar),
              0,
            ),
          )}
        </div>
      );
    },
  },
  {
    accessor: "i_att",
    Header: () => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>AT&T</div>
      );
    },
    showTotal: true,
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <Col style={{ textAlign: "center" }}>{FormatInt(rowInfo.i_att)}</Col>
      );
    },
    Footer: (columnData) => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          {FormatInt(
            columnData.data.reduce(
              (i_total, item) => i_total + Number(item.i_att),
              0,
            ),
          )}
        </div>
      );
    },
  },
  {
    accessor: "i_longcarrier",
    Header: () => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          LongCarrier
        </div>
      );
    },

    showTotal: true,
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <Col style={{ textAlign: "center" }}>
          {FormatInt(rowInfo?.i_longcarrier ?? 0)}
        </Col>
      );
    },
    Footer: (columnData) => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          {FormatInt(
            columnData.data.reduce(
              (i_total, item) => i_total + Number(item.i_longcarrier),
              0,
            ),
          )}
        </div>
      );
    },
  },
  {
    accessor: "i_other",
    Header: () => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>Otros</div>
      );
    },

    showTotal: true,
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <Col style={{ textAlign: "center" }}>{FormatInt(rowInfo.i_other)}</Col>
      );
    },
    Footer: (columnData) => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          {FormatInt(
            columnData.data.reduce(
              (i_total, item) => i_total + Number(item.i_other),
              0,
            ),
          )}
        </div>
      );
    },
  },

  {
    accessor: "i_total",
    Header: () => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Total Envios
        </div>
      );
    },
    showTotal: true,
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <Col style={{ textAlign: "center" }}>{FormatInt(rowInfo.i_total)}</Col>
      );
    },
    Footer: (columnData) => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          {FormatInt(
            columnData.data.reduce(
              (i_total, item) => i_total + Number(item.i_total),
              0,
            ),
          )}
        </div>
      );
    },
  },
];
const AdminSmsCarrierList = ({ listMessages, periodStr, loading }) => {
  return (
    <>
      <div className="flex justify-end items-center gap-2 mb-1">
        <div className="DbDetails2">
          <Stack direction="horizontal" gap={2}>
            <AiIcons.AiOutlineCalendar />
            <div className="ms-auto">
              <p>{periodStr}</p>
            </div>
          </Stack>
          <div className="details">Rango de fechas</div>
        </div>
      </div>

      <div className="bg-white p-3 mb-3 rounded-3">
        <Table
          columns={columns}
          title="Resumen"
          data={listMessages}
          loading={loading}
          config={{
            search: true,
            pagination: true,
            pageSize: 10,
            perPage: 10,
            footer: true,
            export: true,
          }}
        />
      </div>
    </>
  );
};
AdminSmsCarrierList.propTypes = {
  listMessages: PropTypes.array.isRequired,
  periodStr: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
};
export default AdminSmsCarrierList;
